const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

const utf8Decode = (e) => {
    let t = '';
    let n = 0;
    // eslint-disable-next-line no-undef
    let r = 0;
    let c2 = 0;
    while (n < e.length) {
        r = e.charCodeAt(n);
        if (r < 128) {
            t += String.fromCharCode(r);
            n++;
        } else if (r > 191 && r < 224) {
            // eslint-disable-next-line no-undef
            c2 = e.charCodeAt(n + 1);
            // eslint-disable-next-line no-undef
            t += String.fromCharCode((r & 31) << 6 | c2 & 63);
            n += 2;
        } else {
            // eslint-disable-next-line no-undef
            c2 = e.charCodeAt(n + 1);
            // eslint-disable-next-line no-undef
            c3 = e.charCodeAt(n + 2);
            // eslint-disable-next-line no-undef
            t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
            n += 3;
        }
    }
    return t;
};

const decode = (e) => {
    let t = '';
    let n, r, i;
    let s, o, u, a;
    let f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
        s = keyStr.indexOf(e.charAt(f++));
        o = keyStr.indexOf(e.charAt(f++));
        u = keyStr.indexOf(e.charAt(f++));
        a = keyStr.indexOf(e.charAt(f++));
        n = s << 2 | o >> 4;
        r = (o & 15) << 4 | u >> 2;
        i = (u & 3) << 6 | a;
        t = t + String.fromCharCode(n);
        if (u != 64) {
            t = t + String.fromCharCode(r);
        }
        if (a != 64) {
            t = t + String.fromCharCode(i);
        }
    }
    return utf8Decode(t);
};

export { decode };
